import AddressAutoComplete from '../_lib/_address-auto-complete';

function initializeInquiryForm() {
  const inquiryForm = document.querySelector('#rekagoo-form');

  new AddressAutoComplete({
    postalCode: inquiryForm.querySelector('input[name="customer_inquiry[postal_code]"]'),
    prefecture: inquiryForm.querySelector('select[name="customer_inquiry[prefecture_id]"]'),
    city: inquiryForm.querySelector('input[name="customer_inquiry[city]"]'),
    street: inquiryForm.querySelector('input[name="customer_inquiry[street]"]'),
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeInquiryForm();
});
